<button mat-button class="btn_primary_filled"
  [ngClass]="{'btn_primary_filled_icon-right': !iconPosition, 'btn_primary_filled_icon-left': iconPosition}"
  [style.width]="resolvedWidth"
  [style.maxWidth]="resolvedWidth"
  [disabled]="disabled" (click)="onClick()">
  <mat-icon [class]="iconClass" *ngIf="icon && typeIcon">{{ icon
    }}
  </mat-icon>
  {{ label }}
</button>